"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toEnum = toEnum;
exports.hasMember = hasMember;
exports.sleep = sleep;
exports.isNumber = isNumber;
exports.stringToBoolean = stringToBoolean;
function toEnum(enumType, value) {
    return enumType[value];
}
function hasMember(array, item) {
    if (Array.isArray(array) && item) {
        return array.includes(item);
    }
    return false;
}
function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
function isNumber(value) {
    return ((typeof value === "number" && !Number.isNaN(value)) ||
        (typeof value === "string" && !isNaN(Number(value)) && !isNaN(parseFloat(value))));
}
function stringToBoolean(str) {
    const strValue = typeof str === 'string'
        ? str
        : str?.str || '';
    return strValue.toLowerCase() === 'true';
}
